import React from 'react';

export function Footer() {
  return (
    <div className="text-center p-10 mt-10 border-t dark:border-gray-700 border-gray-200 ">
      © 2022 Google Search, Inc.
    </div>
  );
}
